export default {
    slug: 'hosting',
    ability: 'hosting',
    routes: [
        {
            path: 'hosting/domains',
            name: 'hosting-domain-list',
            component: () => import('@modules/Hosting/Resources/js/pages/hosting/domains/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'hosting-domain-preview',
                    component: () => import('@modules/Hosting/Resources/js/pages/hosting/domains/Preview.vue'),
                    redirect: { name: 'hosting-domain-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/hosting/domains/:id(\\d+)',
                            name: 'hosting-domain-overview',
                            component: () =>
                                import('@modules/Hosting/Resources/js/pages/hosting/domains/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'documents/:docPath(.*)*',
                            name: 'hosting-domain-documents',
                            component: () => import('@/components/base/tabs/TabDocuments.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        {
            path: 'hosting/servers',
            name: 'hosting-server-list',
            component: () => import('@modules/Hosting/Resources/js/pages/hosting/servers/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'hosting-server-preview',
                    component: () => import('@modules/Hosting/Resources/js/pages/hosting/servers/Preview.vue'),
                    redirect: { name: 'hosting-server-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/hosting/servers/:id(\\d+)',
                            name: 'hosting-server-overview',
                            component: () =>
                                import('@modules/Hosting/Resources/js/pages/hosting/servers/preview/Overview.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        {
            path: 'hosting/accounts',
            name: 'hosting-account-list',
            component: () => import('@modules/Hosting/Resources/js/pages/hosting/accounts/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'hosting-account-preview',
                    component: () => import('@modules/Hosting/Resources/js/pages/hosting/accounts/Preview.vue'),
                    redirect: { name: 'hosting-account-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/hosting/accounts/:id(\\d+)',
                            name: 'hosting-account-overview',
                            component: () =>
                                import('@modules/Hosting/Resources/js/pages/hosting/accounts/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'comments',
                            name: 'hosting-account-comments',
                            component: () => import('@/components/base/tabs/TabComments.vue'),
                            props: true
                        },
                        {
                            path: 'documents/:docPath(.*)*',
                            name: 'hosting-account-documents',
                            component: () => import('@/components/base/tabs/TabDocuments.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        {
            path: 'hosting/incidents',
            name: 'hosting-incidents',
            component: () => import('@modules/Hosting/Resources/js/pages/hosting/Incidents.vue')
        }
    ],
    settingsRoutes: [
        {
            path: 'hosting',
            name: 'settings-hosting',
            component: () => import('@modules/Hosting/Resources/js/pages/hosting/settings/HostingSettings.vue'),
            props: true
        }
    ],
    settings: () => [
        {
            title: i18n.t('Administration'),
            order: 30,
            items: [{ title: i18n.t('Hosting'), icon: 'server', route: 'settings-hosting', admin: true }]
        }
    ],
    portalRoutes: [
        {
            path: 'hosting/servers',
            name: 'portal-hosting-servers',
            component: () => import('@modules/Hosting/Resources/js/portal/Servers.vue')
        },
        {
            path: 'hosting/servers/:id(\\d+)',
            name: 'portal-hosting-server-detail',
            component: () => import('@modules/Hosting/Resources/js/portal/ServerDetail.vue'),
            props: true
        },
        {
            path: 'hosting/accounts',
            name: 'portal-hosting-accounts',
            component: () => import('@modules/Hosting/Resources/js/portal/Accounts.vue')
        },
        {
            path: 'hosting/accounts/:id(\\d+)',
            name: 'portal-hosting-account-detail',
            component: () => import('@modules/Hosting/Resources/js/portal/AccountDetail.vue'),
            props: true
        },
        {
            path: 'hosting/domains',
            name: 'portal-hosting-domains',
            component: () => import('@modules/Hosting/Resources/js/portal/Domains.vue')
        },
        {
            path: 'hosting/domains/:id(\\d+)',
            name: 'portal-hosting-domain-detail',
            component: () => import('@modules/Hosting/Resources/js/portal/DomainDetail.vue'),
            props: true
        },
        {
            path: 'hosting/domains/register',
            name: 'portal-hosting-domain-register',
            component: () => import('@modules/Hosting/Resources/js/portal/DomainRegister.vue')
        }
    ],
    nav: () => ({
        section: 'hosting',
        items: [
            { title: i18n.t('Domains'), icon: 'web', to: { name: 'hosting-domain-list' } },
            { title: i18n.t('Servers'), icon: 'server-network', to: { name: 'hosting-server-list' } },
            { title: i18n.t('Accounts'), icon: 'account-box-outline', to: { name: 'hosting-account-list' } },
            { title: i18n.t('Incidents'), icon: 'alert-circle-outline', to: { name: 'hosting-incidents' } }
        ]
    })
};
